export const IDP_GROUP_MAPPING_URL = "/settings/idp-group-mapping";
